import React from 'react';
import { AuthProvider, useAuth } from './components/AuthContext';

const ProjectList = () => {
  const { user, loading, login, logout } = useAuth();

  return (
    <main className="page">
      <header className="page-header">
        <div>
          <h1>Dotroe</h1>
          <p className="subtitle">Projects and archives.</p>
        </div>
        <div className="auth-actions">
          {loading ? (
            <span className="status">Checking session...</span>
          ) : user ? (
            <>
              <span className="status">Signed in as {user.name}</span>
              <button className="button secondary" onClick={logout} type="button">
                Sign Out
              </button>
            </>
          ) : (
            <button className="button primary" onClick={login} type="button">
              Sign In
            </button>
          )}
        </div>
      </header>

      <section className="projects">
        <h2>Projects</h2>
        <ul className="project-list">
          <li className="project-card">
            <div className="project-heading">
              <a className="project-link" href="/projects/productivity/">Productivity</a>
              <span className="badge active">Active</span>
            </div>
            <p className="project-note">Time tracking with recurring tasks, Pomodoro timer, and weekly schedule.</p>
          </li>
          <li className="project-card">
            <div className="project-heading">
              <a className="project-link" href="/projects/bargolf/">Bar Golf</a>
              <span className="badge">Archived</span>
            </div>
            <p className="project-note">A past Bar Golf scoreboard and photo gallery.</p>
          </li>
        </ul>
      </section>
    </main>
  );
};

const App = () => (
  <AuthProvider>
    <ProjectList />
  </AuthProvider>
);

export default App;
